import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ITrackArtistResponse } from './types';

export const useGetTrackArtists = (id: string, enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITrackArtistResponse[], DefaultError>({
    queryKey: ['track-artists', id],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Track/GetArtistList`,
        params: { trackId: id },
      });

      return responseHandler(response, {
        groupName: `useGetTrackArtists - ${id}`,
        notFoundPath: '/track',
      });
    },
    enabled: enabled,
  });
};
